import { Height } from '@mui/icons-material';
import React, { useState } from 'react';

type Props = {};

const TwoFactorAuthPage = (props: Props) => {
  const [authData, setAuthData] = useState({
    username: '',
    password: '',
    cancelAuth: false,
  });

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value, type, checked } = e.target;
    setAuthData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Two-Factor Authentication Data:', authData);
    if (authData.cancelAuth) {
      alert('Two-Factor Authentication Cancelled!');
    } else {
      alert('Two-Factor Authentication Updated!');
    }
  };

  const containerStyle = {
    maxWidth: '100%',
    margin: '0 auto',
    boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)',
    padding: '20px',
    borderRadius: '0px',
    height:'80%'
  };

  const inputStyle = {
    width: '60%',
    padding: '8px',
    marginBottom: '15px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '12px',
    backgroundColor: '#F5F5F5',
  };

  const buttonStyle = {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#1173B7',
    color: 'white',
    cursor: 'pointer',
    fontSize: '12px',
    width: '60%',
  };

  const labelStyle = {
    fontSize: '12px',
    marginBottom: '5px',
    display: 'block',
  };

  const titleStyle = {
    fontSize: '12px',
    marginBottom: '20px',
    textAlign: 'left' as const,
  };

  const messageStyle = {
    color: 'green',
    fontSize: '12px',
    marginBottom: '10px',
  };

  return (
    <div style={containerStyle}>
      <div style={{ width: '40%', textAlign: 'left' }}>
        <h2 style={titleStyle}>Setup Two-Factor Authentication:</h2>
        <p style={messageStyle}>
          You have successfully activated the Two-Factor Authentication!
        </p>
        <p style={{ fontSize: '12px', marginBottom: '20px' }}>
          To cancel it, enter your account's credentials and mark the checkbox
          below <em>(not recommended)</em>.
        </p>
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="username" style={labelStyle}>
              Username:
            </label>
            <input
              id="username"
              type="text"
              name="username"
              value={authData.username}
              onChange={handleInputChange}
              required
              placeholder="Enter your username"
              style={inputStyle}
            />
          </div>

          <div>
            <label htmlFor="password" style={labelStyle}>
              Password:
            </label>
            <input
              id="password"
              type="password"
              name="password"
              value={authData.password}
              onChange={handleInputChange}
              required
              placeholder="Enter your password"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: '15px', fontSize:'12px' }}>
            <label>
              <input
                type="checkbox"
                name="cancelAuth"
                checked={authData.cancelAuth}
                onChange={handleInputChange}
              />{' '}
              Cancel Two-Factor Authentication
            </label>
          </div>

          <button type="submit" style={buttonStyle}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default TwoFactorAuthPage;